import { useEffect } from 'react'

const useKeylistener = (onKeydown: (e: KeyboardEvent) => void, paramtersList = new Array<any>()) => {
  useEffect(() => {
    document.addEventListener('keydown', onKeydown)

    return () => {
      document.removeEventListener('keydown', onKeydown)
    }
  }, paramtersList)
}

export default useKeylistener
